import { memo } from 'react';

import { ReactComponent as ArrowDown } from '../../../../assets/icons/ArrowDown.svg';
import useSelect from '../../../../services/hooks/UI/useSelect';
import { formTypes } from '../../../../store/catalogs/forms';
import DisplayOptions from '../DisplayOptions/DisplayOptions';

import classes from './Select.module.scss';

export const selectStyles = {
  form: 'form',
  filter: 'filter'
};

const Select = ({
  options,
  value,
  error,
  onChange,
  position,
  bottomSpace,
  className,
  typeSelect = 'select',
  style = selectStyles.form,
  name,
  disabled,
  placeholder
}) => {
  const {
    open,
    divRef,
    containerBlurHandler,
    containerClickHandler,
    containerClasses,
    selectValue,
    filteredOptionsOrCreated,
    inputBlurHandler,
    closedOptions,
    inputRef,
    arrowClickHandler,
    selectOptions,
    setOptions,
    labelSelected
  } = useSelect({ value, options, onChange, typeSelect, className, style, error });

  return (
    <div
      name={name}
      tabIndex={0}
      ref={divRef}
      onBlur={containerBlurHandler}
      onClick={disabled ? () => {} : containerClickHandler}
      className={`${disabled ? `${classes.disabled}` : 'pointer '} ${containerClasses.concat(classes.container).join(' ')} `}>
      <span name={name} className='text-ellipsis medium-16'>
        {typeSelect === formTypes.phone ? selectValue.value : selectValue.label}
      </span>
      <ArrowDown className={`${open ? classes.up : ''} select-icon`} onClick={arrowClickHandler} />
      <DisplayOptions
        key='Select'
        toogleOpenHandler={closedOptions}
        classContent='select-options'
        open={open}
        position={position}
        bottomSpace={bottomSpace}
        options={filteredOptionsOrCreated}
        selected={selectValue.value}
        onChange={setOptions}
        value={labelSelected}
        onBlur={inputBlurHandler}
        reference={inputRef}
        selectOptions={selectOptions}
      />
    </div>
  );
};

export default memo(Select);
